import { loadableWithFallback } from '@vision/ui/utils';
import type { GaugeChart2Props } from './GaugeChart2';

export const GaugeChart2 = loadableWithFallback<GaugeChart2Props>(() => import('./GaugeChart2'));
